<script lang="ts">
	import ExchangeMarkets from 'components/ExchangeMarkets/ExchangeMarkets.svelte';
	import MarketOverview from 'components/MarketOverview/MarketOverview.svelte';
	import MetaTags from 'src/components/MetaTags/MetaTags.svelte';
	import { CANONICAL_URL } from 'src/utils/urls';
	import theme from 'stores/theme';

	export let data;

	const metaCanonicalURL = `${CANONICAL_URL}/markets/${data.route}`;
	const metaTitle = `${data.name} exchange markets | CryptoMarketCap`;
	const metaDescription = `${data.name} latest exchange pairs | CryptoMarketCap`;

	$: dark = $theme as boolean;
</script>

<MetaTags
	canonical={metaCanonicalURL}
	title={metaTitle}
	description={metaDescription}
	additionalMetaTags={[
		{ property: 'og:type', content: 'website' },
		{ property: 'og:title', content: metaTitle },
		{ property: 'og:description', content: metaDescription },
		{ property: 'og:url', content: metaCanonicalURL },
		{ property: 'og:site_name', content: 'CryptoMarketCap' },
	]}
/>
<div class="wrapper">
	<section class="market-overview">
		<MarketOverview {dark} marketData={data.marketData}/>
	</section>
	<ExchangeMarkets {dark} name={data.name}/>
</div>

<style lang="scss">
	@import './markets.scss';
</style>
